// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1m44e","slideFromBottom":"Card_slideFromBottom__20nRe"};